import {
  ICategorySoldProducts,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IDeleteCategory {
  updateFormData: (data: TComplexSectionData) => void
  data: ICategorySoldProducts[]
  productCategory: ICategorySoldProducts
}

export const deleteCategory = ({ updateFormData, productCategory, data }: IDeleteCategory) => {
  const updatedData = [...data]
  const foundCategoryIndex = updatedData.findIndex((el) => el.Key === productCategory.Key)
  updatedData.splice(foundCategoryIndex, 1)
  updateFormData(updatedData)
}
